import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminUsers from "@/pages/admin/Users";
import AdminAddTrade from "@/pages/admin/AddTrade";
import AdminOpenTrades from "@/pages/admin/OpenTrades";
import AdminTradeHistory from "@/pages/admin/TradeHistory";
import AdminBulkUpload from "@/pages/admin/BulkUpload";
import AdminWithdrawals from "@/pages/admin/Withdrawals";
import AdminDeposits from "@/pages/admin/Deposits";
import ClientLayout from "@/pages/client/ClientLayout";
import ClientDashboard from "@/pages/client/Dashboard";
import ClientTrades from "@/pages/client/Trades";
import ClientDeposit from "@/pages/client/Deposit";
import ClientWithdrawal from "@/pages/client/Withdrawal";
import ClientProfile from "@/pages/client/Profile";
import Markets from "@/pages/Markets";

function RoleRoute({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== role) return <Navigate to={user.role === "admin" ? "/admin/dashboard" : "/client/dashboard"} replace />;
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin/dashboard" : "/client/dashboard"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <div className="App dark">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />

            <Route
              path="/admin"
              element={
                <RoleRoute role="admin">
                  <AdminLayout />
                </RoleRoute>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="markets" element={<Markets />} />
              <Route path="trades/add" element={<AdminAddTrade />} />
              <Route path="trades/open" element={<AdminOpenTrades />} />
              <Route path="trades/history" element={<AdminTradeHistory />} />
              <Route path="trades/bulk" element={<AdminBulkUpload />} />
              <Route path="withdrawals" element={<AdminWithdrawals />} />
              <Route path="deposits" element={<AdminDeposits />} />
            </Route>

            <Route
              path="/client"
              element={
                <RoleRoute role="client">
                  <ClientLayout />
                </RoleRoute>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<ClientDashboard />} />
              <Route path="trades" element={<ClientTrades />} />
              <Route path="markets" element={<Markets />} />
              <Route path="deposit" element={<ClientDeposit />} />
              <Route path="withdrawal" element={<ClientWithdrawal />} />
              <Route path="profile" element={<ClientProfile />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthProvider>
  );
}
